var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._g(_vm._b({staticStyle:{"color":"#5b7185","border":"1px solid #e8eef1 !important","box-shadow":"0px 2px 6px 0px #00679e1a"},attrs:{"color":"white"}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }